import { ReactNode } from 'react'
import styles from './Note.module.css'

/** 시안 `.note` 이식. 섹션 하단의 작은 보조 설명. */
export type NoteProps = {
  children: ReactNode
}

export const Note = ({ children }: NoteProps): JSX.Element => <p className={styles.note}>{children}</p>
